import SmsCode from "./sms-code";
export default SmsCode;